<template>
    <thead class="hidden sm:table-header-group">
    <tr class="text-gray-500 text-sm">
        <th v-for="column in this.columns" @click="() => sortColumn(column.name)" :class="[sortBy != null ? 'cursor-pointer' : '', 'p-4 text-left w-12']">
            <div class="flex items-center">
                <span class="mr-2">{{ $__(column.translationKey) }}</span>
                <div v-if="showSortIcon">
                    <CaretIcon :fill="[(sortBy?.column === column.name && !sortBy.asc) ? '#000' : '#9CA3AF']" class="rotate-180" />
                    <CaretIcon :fill="[(sortBy?.column === column.name && sortBy.asc) ? '#000' : '#9CA3AF']" />
                </div>
            </div>
        </th>
    </tr>
    </thead>
</template>

<script>
import CaretIcon from '@/Components/Icons/Caret'

export default {
    components: {
        CaretIcon,
    },
    props: ['sortBy', 'columns', 'showSortIcon'],
    methods: {
        sortColumn(key) {
            this.$emit('sortColumn', key);
        },
    }
}
</script>
